export default __webpack_public_path__ + "static/media/img-service.0aaab503.png";